<template>
    <div>
        <div class="mask" v-show="isShowSelect"></div>

            <el-dialog  :title="title" :modal="false" :visible.sync="isShowSelect" :width="multiple?'640px':'300px'"
                       :close-on-click-modal="false" :show-close="false">
            <div class="w100 bg-w page-select" v-loading="loading">
                <slot name="header"></slot>
                <div class="cl-f mb10 mt10" v-if="multiple">
                    <div class="fl h300p card-shadow" style="width: 360px;">
                        <div class="remark-title">
                          可选项
                        </div>
                        <div class="pl20" style="overflow: auto;height:270px;">
                            <el-checkbox v-for="item in leftDataCopy"
                                         v-model="item.checked"
                                         @change="handleChecked($event,item.value,item)"
                                         :label="item.value"
                                         :key="item.value">{{item.name}}</el-checkbox>
                        </div>

                    </div>

                    <div class="fr h300p  card-shadow" style="width: 190px">
                        <div class="remark-title">
                            已选(<span remarkclass="in-block">
                        {{ selectLen }}</span>)个
                        </div>
                        <div class="pl20" style="overflow: auto;height:270px;">


                            <el-checkbox v-for="item in rightData"
                                         :label="item.value"
                                         v-model="item.checked"
                                         @change="handleAlreadyChecked"
                                         :key="item.value">{{item.name}}</el-checkbox>
                        </div>
                    </div>
                </div>


                <div class="card-shadow mb10 h300p pt20 pl20 pr20 pb20" style="overflow: auto;" v-if="!multiple">
                    <div  v-for="item in leftDataCopy" class="pt5 pb5" :class="{'select':singleVal==item.value}">
                    <el-radio v-model="singleVal"
                              :label="item.value"
                              :key="item.value">{{item.name}}</el-radio>
                    </div>
                </div>


                <el-pagination
                        :background="multiple"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="paramSearch.current"
                        :page-sizes="pageSizes"
                        :page-size="paramSearch.size"
                        :layout="multiple?'total, sizes, prev, pager, next, jumper':'prev, pager, next'"
                        :total="total"
                ></el-pagination>

            </div>
                <div slot="footer" class="dialog-footer" style="text-align: right;" >
                    <el-button size="mini"  @click="isShowSelect=false">确定</el-button>
                </div>
            </el-dialog>


        <el-input    :size="size"
                       :style="'width:'+ width"
                       v-if="isShowSelect"
        />
            <el-select
                    slot="reference"
                    v-if="!isShowSelect"
                    ref="select"
                    :size="size"
                    v-model="returnDataKeys"
                    :style="selectWidth"
                    :multiple="multiple"
                    :clearable="clearable"
                    :collapse-tags="collapseTags"
                    @click.native="selectClick"
                    @remove-tag="removeTag"
                    class="tree-select">

                <el-option
                        v-for="item in rightData" :key="item.value"
                        :label="item.name" :value="item.value">{{item.name}}
                </el-option>
            </el-select>
    </div>

</template>

<script>
    export default {
        name: "byPageSelect",
        props: {
            // 标题
            title: {
                type: String,
                default () {
                    return '选择器';
                }
            },
            // 左侧数据
            leftData: {
                type: Array,
                default () {
                    return [];
                }
            },
            collapseTags: {
                type: Boolean,
                default () {
                    return false;
                }
            },
            // 配置是否可多选
            multiple: {
                type: Boolean,
                default () {
                    return false;
                }
            },
            clearable: {
                type: Boolean,
                default () {
                    return false;
                }
            },
            size: {
                type: String,
                default () {
                    return 'small';
                }
            },
            width: {
                type: String,
                default () {
                    return '100%';
                }
            },
            height: {
                type: String,
                default () {
                    return '300px';
                }
            },
            selectWidth: {
                type: String,
                default () {
                    return 'width: 300px';
                }
            },
            pageSizes: {
                type: Array,
                default () {
                    return [10, 20, 30, 50, 100];
                }
            },
            paramSearch: {
                type: Object,
                default () {
                    return {
                        current:1,
                        size:10,
                    }
                }
            },
            total: {
                type: Number,
                default () {
                    return 0;
                }
            }
        },
        //上面是父组件可传入参数
        data () {
            return {
                loading:false,
                leftDataCopy:[],
                rightData:[],
                rightDataVal:[],
                singleVal:'',
                serveList:[],
                isShowSelect: false, // 是否显示选择器
                options: [],//select option选项
                returnDatas:[],//返回给父组件数组对象
                returnDataKeys:[],//返回父组件数组主键值
            };
        },
        computed: {
            selectLen(){
                return this.rightData.length
            }
        },
        methods:{
            sureSelect(){

            },
            handleCurrentChange(){
                this.$emit('handleCurrentChange',...arguments)

            },
            handleSizeChange(){
                this.$emit('handleSizeChange',...arguments)
            },
            handleAlreadyChecked(checked){
                if(!checked){
                    const data=this.rightData.filter(i=>{
                        return i.checked
                    })
                    const obj=this.rightData.find(i=>{
                        return !i.checked
                    })
                    this.leftDataCopy.forEach(i=>{
                        if(obj.value == i.value){
                            i.checked=false
                        }
                    })
                    this.rightData =data
                }

            },
            handleChecked(checked,value,item){
                if(!checked){
                    const data= this.rightData.filter(i=>{
                        return value!= i.value
                    })
                    this.rightData =data

                }else{
                    this.rightData.push(item)

                }

            },
            selectClick(){


                return this.isShowSelect = !this.isShowSelect

            },
            removeTag(value){
                const data= this.rightData.filter(i=>{
                    return value!= i.value
                })
                this.rightData =data
                this.leftDataCopy.forEach(i=>{
                    if(value == i.value){
                        i.checked=false
                    }
                })

            },
            setToading(flag){
                this.loading=flag
            },
            valueSelect(obj){
                if(obj){
                    this.rightData=[obj]
                    this.singleVal=obj.value
                    this.returnDataKeys=obj.value
                }else{
                    this.rightData=[]
                    this.singleVal=""
                    this.returnDataKeys=""
                    this.$emit('setValue',"")
                }


            },

        },

        watch:{

            leftData(val){
                if(this.multiple){
                    this.leftDataCopy=val.map(i=>{
                        return{
                            ...i,
                            checked:this.rightDataVal.indexOf(i.value)==-1?false:true
                        }
                    })
                }else{
                    this.leftDataCopy=val.map(i=>{
                        return{
                            ...i
                        }
                    })
                }


            },
            rightData(val){
                this.rightDataVal =val.map(i=>i.value)
            },
            isShowSelect(val){
                if(!val){
                    if(this.multiple){
                        this.returnDataKeys=this.rightData.map(i=>i.value)
                    }else{
                        this.returnDataKeys=this.rightData[0].value
                    }

                }
            },
            returnDataKeys(val){

                this.$emit('setValue',val)
            },
            singleVal(val){
                if(this.leftDataCopy.length){
                    let obj =this.leftDataCopy.find(i=>i.value == val)
                    this.rightData=[obj]
                }else{

                }

            }

        }
    }
</script>

<style scoped>
    .remark-title{
        height: 30px;
        line-height: 30px;
        background:rgba(6, 69, 118,0.7);
        color: #fff;
        font-size: 14px;
        text-align: center;
    }
    .page-select .el-dialog__body{
    padding: 0 20px;
}
    .el-select-dropdown{
        display: none;
    }
    .tree-select{
        z-index: 1;
    }
</style>
<style>
    .page-select .el-checkbox__label{
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: -6px;
    }
    .page-select .el-checkbox{
        padding: 8px 0;
    }
    [role="tooltip"]{
        top:36px;
        overflow: auto;
    }
</style>
